import { render, staticRenderFns } from "./fbaDetailDialog.vue?vue&type=template&id=0dab60f2&scoped=true"
import script from "./fbaDetailDialog.vue?vue&type=script&lang=js"
export * from "./fbaDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./fbaDetailDialog.vue?vue&type=style&index=0&id=0dab60f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab60f2",
  null
  
)

export default component.exports